import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "hideable", "icon", "text" ]
  static values = {
    display: { type: String, default: "block" },
    localStorageName: String,
    hideText: String,
    showText: String,
    startCollapsed: { type: Boolean, default: false }
  }
  static classes = [ "hide", "show" ]

  connect() {
    if (this.localStorageNameValue) {
      const stored = localStorage.getItem(this.localStorageNameValue)
      const isHidden = stored === null ? this.startCollapsedValue : stored === "true"
      if (isHidden) {
        this.hideableTargets.forEach(el => this.hide(el))
      } else {
        this.hideableTargets.forEach(el => this.show(el))
      }
      this.updateText(!isHidden)
    } else if (this.startCollapsedValue) {
      this.hideableTargets.forEach(el => this.hide(el))
      this.updateText(false)
    }
  }

  show(el) {
    el.style.display = this.displayValue;
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove(this.showClass);
      this.iconTarget.classList.add(this.hideClass);
    }
  }

  hide(el) {
    el.style.display = "none";
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove(this.hideClass);
      this.iconTarget.classList.add(this.showClass);
    }
  }

  toggleTargets() {
    // Use getComputedStyle to detect if element is hidden via CSS or inline styles
    const isCurrentlyHidden = window.getComputedStyle(this.hideableTargets[0]).display === "none";

    this.hideableTargets.forEach((el) => {
      if (isCurrentlyHidden) {
        this.show(el)
      } else {
        this.hide(el)
      }
    });

    this.updateText(!isCurrentlyHidden);

    if (this.hasLocalStorageNameValue) {
      localStorage.setItem(this.localStorageNameValue, !isCurrentlyHidden)
    }
  }

  updateText(isVisible) {
    if (this.hasHideTextValue && this.hasShowTextValue && this.hasTextTarget) {
      this.textTarget.textContent = isVisible ? this.hideTextValue : this.showTextValue;
    }
  }

  // Convenience methods for showing/hiding all targets (useful for radio buttons)
  showTargets() {
    this.hideableTargets.forEach(el => this.show(el))
  }

  hideTargets() {
    this.hideableTargets.forEach(el => this.hide(el))
  }
}
